import { compose } from 'recompose';

import resetFiltersHoc from '../hoc/resetFiltersHoc';
import withNewDesignStyles from '../../../common/hoc/withNewDesignStyles';

const BarberSalesSummaryContainer = compose(
  resetFiltersHoc,
  withNewDesignStyles,
);

export default BarberSalesSummaryContainer;
